import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { LegacySkin } from '@/shared/components/layout/LegacySkin'
import { TopNav } from '@/shared/components/layout/TopNav'
import { useAppStore } from '@/shared/stores/appStore'

export const Route = createFileRoute('/_public')({
  beforeLoad: async ({ context }) => {
    // Mirror _authenticated.tsx: wait for the first onAuthStateChange so the
    // session is hydrated, then read it from the store (the single source of
    // truth — context.auth.session is captured once at boot and goes stale).
    // An already-authenticated user hitting / or /entrar goes straight to /home.
    await context.auth.ready
    if (useAppStore.getState().session) {
      throw redirect({ to: '/home' })
    }
  },
  component: PublicLayout,
})

function PublicLayout() {
  return (
    <>
      {/* The landing sections and the auth flow are the last screens still
          baked for the dark ground — 63 raw rgba() and 14 hardcoded hex between
          them. Light is now the default, so without this pin a logged-out
          visitor would meet the new theme on the two screens that cannot yet
          render it. Remove it when auth is migrated and the landing copy is
          settled; it is the same mechanism frozen fantasy uses. */}
      <LegacySkin />
      <TopNav />
      <Outlet />
    </>
  )
}
